import { SortDirections } from "@app/shared/waffles";

/**
 * Sorts a given array<T> by a specified date property (dateKey)
 * @param data The dataset to sort
 * @param dateKey The date property used for sorting
 * @param direction The sort direction
 * @param noDateKey The property to use for sorting if primary dateKey is null or the same
 * @param noDateKey2 The optional secondary property, if no date need sorted from nested property, to use for sorting if primary dateKey is null or the same.
 * * An example when to use noDateKey2 is when sorting by a nested property like: property.nestedProperty.
 * * No Date Key would be property and No Date Key 2 would be nestedProperty.
 * @returns sorted array<T>
 */

function sortByDate<T, K extends keyof T, K2 extends keyof T>(data: T[], dateKey: K, direction: string, noDateKey: K2, noDateKey2?: keyof T[K2]): T[] {

  const multiplier = direction === SortDirections.Asc ? 1 : -1;
  const noDate: T[] = [];
  const withDate: T[] = [];
  const combinedResult: T[] = [];

  data.forEach((d) => {
    if (isNaN(Date.parse(d[dateKey] as string))) {
      noDate.push(d);
    } else {
      withDate.push(d);
    }
  });

  if (!!noDateKey2) {
    noDate.sort((a, b) => { return (a[noDateKey][noDateKey2] > b[noDateKey][noDateKey2] ? 1 : -1) * multiplier; });
  } else {
    noDate.sort((a, b) => { return (a[noDateKey] > b[noDateKey] ? 1 : -1) * multiplier; });
  }

  withDate.sort((a, b) => {
    const aDate = new Date(a[dateKey] as string);
    const bDate = new Date(b[dateKey] as string);
    if (aDate.toString() === bDate.toString()) {
      if (!!noDateKey2) {
        return (a[noDateKey][noDateKey2] > b[noDateKey][noDateKey2] ? 1 : -1) * multiplier;
      } else {
        return (a[noDateKey] > b[noDateKey] ? 1 : -1) * multiplier;
      }
    }
    return (aDate > bDate ? 1 : -1) * multiplier;
  });

  if (direction === SortDirections.Asc) {
    combinedResult.push(...noDate, ...withDate);
  } else {
    combinedResult.push(...withDate, ...noDate);
  }
  return combinedResult;
}

export { sortByDate };